<template>
    <div class="bg-white rounded-lg shadow p-6">
        <h3 class="text-lg font-semibold text-gray-700 mb-2">{{ title }}</h3>
        <div v-if="loading" class="animate-pulse">
            <div class="h-8 bg-gray-200 rounded w-3/4"></div>
        </div>
        <div v-else class="text-2xl font-bold text-gray-900">
            {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'BoxDashboard',
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>